import { render, staticRenderFns } from "./registrationCodeDisplay.vue?vue&type=template&id=55b78c75&scoped=true&"
import script from "./registrationCodeDisplay.vue?vue&type=script&lang=js&"
export * from "./registrationCodeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b78c75",
  null
  
)

export default component.exports